import React, { memo } from "react";
import { IPrefillData } from "../../stores/formsStore";

interface IProps {
    prefillData: IPrefillData;
}

const OfficeHeader: React.FC<IProps> = memo(({ prefillData }) => {
  const officeLogo = prefillData.LogoUrl;
  if (officeLogo) {
      return <div><img src={officeLogo} alt="" style={{ width: 120 }} /></div>
  }
  else {
      return <span></span>
  }
});

export default OfficeHeader;
